var labelsByDay = {
    mon: 'Poniedziałek',
    tue: 'Wtorek',
    wed: 'Środa',
    thu: 'Czwartek',
    fri: 'Piątek',
    sat: 'Sobota',
    sun: 'Niedziela',
};
var daysSorted = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
export var getAvailabilityLabel = function (menuItem) {
    if (!menuItem.availability) {
        return 'Dostępny cały czas';
    }
    var availability = menuItem.availability;
    var availableFullTimeDays = daysSorted.filter(function (day) { return availability[day].isAvailable && availability[day].isFullDay; });
    if (availableFullTimeDays.length === 7) {
        return 'Dostępny cały czas';
    }
    var availableDays = daysSorted.filter(function (day) { return availability[day].isAvailable; });
    var availableDaysLabels = availableDays.map(function (day) {
        var daily = availability[day];
        if (daily.isFullDay) {
            return labelsByDay[day].toLowerCase();
        }
        var hourFrom = daily.hourFrom, minuteFrom = daily.minuteFrom, hourTo = daily.hourTo, minuteTo = daily.minuteTo;
        return "".concat(labelsByDay[day].toLowerCase(), " (").concat(hourFrom, ":").concat(minuteFrom === null || minuteFrom === void 0 ? void 0 : minuteFrom.toString().padEnd(2, '0'), " - ").concat(hourTo, ":").concat(minuteTo === null || minuteTo === void 0 ? void 0 : minuteTo.toString().padEnd(2, '0'), ")");
    });
    return "Dost\u0119pny w dniach: ".concat(availableDaysLabels.join(', '));
};
export function isAvailableNow(menuItem) {
    if (!menuItem.availability) {
        return true;
    }
    var now = new Date();
    var currentDayKey = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'][now.getDay()];
    var currentDayAvailability = menuItem.availability[currentDayKey];
    if (!currentDayAvailability.isAvailable) {
        return false;
    }
    if (currentDayAvailability.isFullDay) {
        return true;
    }
    var startTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), currentDayAvailability.hourFrom, currentDayAvailability.minuteFrom);
    var endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), currentDayAvailability.hourTo, currentDayAvailability.minuteTo);
    return now > startTime && now < endTime;
}
